import React, { useEffect, useState } from "react";
// import Header from "../../Layout/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { allapiAction } from "../../../Redux/common/action";
import { Table } from "antd";
import moment from "moment";
import NewHeader from "../Layout/NewHeader";
import NewSidebar from "../Layout/NewSidebar";
import { allapiAction } from "../../Redux/common/action";
// import NewHeader from "../../Layout/NewHeader";
// import NewSidebar from "../../Layout/NewSidebar";
function WithdrwalListMain() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;
  const [pages, setPage] = useState(1);
  const order_list = useSelector((state) =>
    state?.allapi?.get_withdrawal_requset_list
      ? state?.allapi?.get_withdrawal_requset_list
      : {}
  );
  const listdata = order_list?.docs ? order_list?.docs : [];

  useEffect(() => {
    // if (search) {
    //   dispatch(allapiAction.getSearchOrdervendor({ page: page, key: search }));
    // } else {
    dispatch(allapiAction.getWithdrawalListverndor(page));
    // }
    // dispatch(allapiAction.getInvoceDetails());
    return () => {};
  }, [location]);

  const hendlePahegi = (e) => {
    setPage(e);

    console.log(location);

    navigate("/withdrawl-list?page=" + e + "&&search=" + search);
  };
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
  {
      title: "Request Payment",
      dataIndex: "requestPayment",
      key: "requestPayment",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.requestPayment}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },
  {
      title: "TDS",
      dataIndex: "requestPayment",
      key: "requestPayment",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.requestPayment-item.payablePayment}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },
    {
      title: "Payable Payment",
      dataIndex: "payablePayment",
      key: "payablePayment",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.payablePayment}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },
  
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.reason}

              {/* <p> {item?.user_id?.referId}</p> */}
            </span>
          </>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {moment(item?.createdAt).format(" DD/MM/YYYY ")}
            </span>
          </>
        );
      },
    },

    // {
    //   title: "Amount",
    //   dataIndex: "sub_total",
    //   key: "sub_total",
    // },
    // {
    //   title: "Payment Mode",
    //   dataIndex: "payment_mode_name",
    //   key: "payment_mode_name",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    // {
    //   title: "Order return",
    //   dataIndex: "orderretune",
    //   key: "orderretune",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <span
    //           className="cursor-pointer"
    //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
    //         >
    //           {item?.orderretune == "true" ? "Yes" : "No"}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   key: "action",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>

    //         <Tooltip title="Invoice">
    //           <button
    //             className="filter-button ml-3  mt-5"
    //             onClick={() => hendleToViewM(item)}
    //           >
    //             Invoice
    //           </button>
    //         </Tooltip>
    //         <Tooltip title="View">
    //           <button
    //             className="filter-button ml-3  mt-5"
    //             onClick={() => hendleToViewProduct(item)}
    //           >
    //             View
    //           </button>
    //         </Tooltip>

    //       </>
    //     );
    //   },
    // },
  ];
  return (
    <div>
      <NewHeader />
      <NewSidebar />
      <div className="main">
      <div classsName="my">
        <div class="container mt-5 pt-5 mb-5 pb-5">
          <div className="tableResponsive mt-10">
            <Table
              className={"table antd_table"}
              dataSource={listdata}
              columns={columns}
              pagination={{
                current: parseInt(page),
                pageSize: 10,
                onChange(current, pageSize) {
                  hendlePahegi(current);
                },
                hideOnSinglePage: true,
                total: order_list?.totalDocs ? order_list?.totalDocs : 0,
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
    </div>
  );
}

export default WithdrwalListMain;
